export const AUTH_URL = `https://auth.freshbooks.com/service/auth/oauth/authorize?client_id=${
  process.env.REACT_APP_FRESHBOOK_CLIENT_ID
}&redirect_uri=${encodeURI(
  process.env.REACT_APP_FRESHBOOK_REDIRECT_URI!
)}&response_type=code&scope=user%3Aprofile%3Aread%20user%3Atime_entries%3Aread%20user%3Aclients%3Aread%20user%3Aclients%3Awrite%20user%3Abusiness%3Aread%20user%3Atime_entries%3Awrite%20user%3Abillable_items%3Awrite%20user%3Abillable_items%3Aread%20user%3Ateams%3Aread`;
